module.exports = __webpack_public_path__ + "img/logo_fidelize.bc27e19d.png";